import { supabase } from '@/integrations/supabase/client';
import { deviceTokenHeaders } from '@/lib/device-token';

export const PASS_SERVER_URL = import.meta.env.VITE_PASS_GENERATOR_URL || 'https://pass.taginn.app';

/**
 * fetch() to pass-generator-server with the caller's credentials: the signed-in user's
 * Supabase token and/or the scanner/kiosk device token. The server rejects owner and
 * scanner routes without one of them.
 */
export async function passServerFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  const { data: { session } } = await supabase.auth.getSession();
  if (session?.access_token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${session.access_token}`);
  }
  for (const [name, value] of Object.entries(deviceTokenHeaders())) headers.set(name, value);
  return fetch(`${PASS_SERVER_URL}${path}`, { ...init, headers });
}
